// tslint:disable:max-line-length

import React from 'react';

export const EditorDelete = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4,2L0,8l4,6h12V2H4z M8,4.6l2,2l2-2L13.4,6l-2,2l2,2L12,11.4l-2-2l-2,2L6.6,10l2-2l-2-2C6.6,6,8,4.6,8,4.6z" />
    </svg>
  );
};
